import { Checkbox, Col, DatePicker, Form, Input, Modal, Row, Select } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import "react-phone-input-2/lib/style.css";
import apiPath from "../../constants/apiPath";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
const { Option } = Select;

const AddNotificationModal = ({ section, show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);

  const [Users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectAllUsers, setSelectAllUsers] = useState(false);
  const [isScheduled, setIsScheduled] = useState(false);

  const SELECTION_LIMIT = 5;

  const getUserList = () => {
    request({
      url: apiPath.common.userList,
      method: "GET",
      onSuccess: ({ data: users, status }) => {
        if (status) {
          const user = users.filter((u) => u.type === "Customer");
          setUsers(user);

          if (data?.user_id?.length) {
            const userIds = user.map((u) => u._id);
            setSelectedUsers(
              data.user_id.filter((id) => userIds.includes(id))
            );
          }
        }
      },
      onError: () => {
        ShowToast("Failed to load user list", Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    getUserList();
  }, []);

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        title: data.title || "",
        message: data.message || "",
      });

      if (data.isSelectAllUser) {
        setSelectAllUsers(true);
        setSelectedUsers([]);
      } else {
        setSelectAllUsers(false);
        setSelectedUsers(data.user_id || []);
      }
    } else {
      form.resetFields();
      setSelectAllUsers(false);
      setSelectedUsers([]);
    }
  }, [data]);


  const onCreate = (values) => {
    const payload = {
      ...values,
      notification_type: values.notification_type,
      user_id: selectAllUsers ? [] : selectedUsers,
      audience: selectAllUsers ? "Customer" : undefined,
    };
    delete payload._id;

    setLoading(true);
    request({
      // url: data ? `${apiPath.notification}/${data._id}` : apiPath.notification,
      url: apiPath.notification,
      method: "POST",
      data: payload,
      onSuccess: (res) => {
        setLoading(false);
        if (res.status) {
          ShowToast(res.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(res.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error?.response?.data?.message || "Error", Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const handleSelectAllUsers = (e) => {
    const checked = e.target.checked;
    setSelectAllUsers(checked);
    setSelectedUsers(checked ? Users.map((u) => u._id) : []);
  };

  const handleUserSelection = (value) => {
    if (value.length > SELECTION_LIMIT) {
      ShowToast(`You can only select up to ${SELECTION_LIMIT} users`, Severty.WARNING);
      return;
    }
    setSelectedUsers(value);
  };

  return (
    <Modal
      width={600}
      open={show}
      onCancel={hide}
      okText={data ? "Update" : "Add"}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
      className="tab_modal"
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <h4 className="modal_title_cls">
          {data ? "Resend Notification" : "Create Notification"}
        </h4>

        <Row gutter={[16, 0]} className="w-100">
          <Col span={24}>
            <Form.Item
              label="Title"
              name="title"
              initialValue={data?.title || ""}
              rules={[
                { required: true, message: "Please Enter Notification Title" },
                { max: 80, message: "Max 80 characters allowed" },
                { min: 2, message: "Minimum 2 characters required" },
              ]}
              normalize={(value) => value.trimStart()}
            >
              <Input
                placeholder="Enter Notification Title"
                autoComplete="off"
              />
            </Form.Item>
          </Col>

          {/* Select All User */}
          <Col span={24}>
            <Checkbox
              checked={selectAllUsers}
              onChange={handleSelectAllUsers}
            >
              Select All User
            </Checkbox>

            {/* Hide Select box when Select All is checked */}
            {!selectAllUsers && (
              <Form.Item
                label={`Select Users (Max ${SELECTION_LIMIT})`}
                help={`${selectedUsers.length}/${SELECTION_LIMIT} selected`}
              >
                <Select
                  mode="multiple"
                  placeholder="Select User"
                  value={selectedUsers}
                  onChange={handleUserSelection}
                  maxTagCount="responsive"
                  options={Users.map((u) => ({
                    value: u._id,
                    label: `${u.name || ""}`,
                  }))}
                />
              </Form.Item>
            )}
          </Col>

          {/* Message */}
          <Col span={24}>
            <Form.Item
              label="Message"
              name="message"
              initialValue={data?.message || ""}
              rules={[{ required: true, message: "Please enter a message" }]}
              normalize={(value) => value.trimStart()}
            >
              <Input
                placeholder="Enter Notification Message"
                autoComplete="off"
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Notification Type"
              name="notification_type"
              initialValue={data?.notification_type || "Push"}
              rules={[{ required: true, message: "Please select notification type" }]}
            >
              <Select>
                <Select.Option value="Push">Push Notification</Select.Option>
                <Select.Option value="In App">In-App Notification</Select.Option>
              </Select>
            </Form.Item>

          </Col>

          {/* Schedule */}
          <Col span={24}>
            <Checkbox checked={isScheduled} onChange={(e) => setIsScheduled(e.target.checked)}>
              Schedule for later
            </Checkbox>
          </Col>

          {isScheduled && (
            <Col span={24}>
              <Form.Item
                name="scheduled_time"
                label="Scheduled Time"
                rules={[{ required: true, message: "Please select schedule time" }]}
              >
                <DatePicker
                  showTime
                  style={{ width: "100%" }}
                  disabledDate={(current) => current && current < dayjs().startOf("day")}
                />
              </Form.Item>
            </Col>
          )}
        </Row>
      </Form>
    </Modal>
  );
};

export default AddNotificationModal;
